import { render, staticRenderFns } from "./SettingStats.vue?vue&type=template&id=b64b17ce&scoped=true"
import script from "./SettingStats.vue?vue&type=script&lang=js"
export * from "./SettingStats.vue?vue&type=script&lang=js"
import style0 from "./SettingStats.vue?vue&type=style&index=0&id=b64b17ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64b17ce",
  null
  
)

export default component.exports